function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// You can blame Sam Huckaby for this file © 2019
export var DynamicDistributedAssets =
/*#__PURE__*/
function () {
  function DynamicDistributedAssets($stateParams, $timeout, DeliveryResourceFactory, AssetResourceFactory, DestinationResourceFactory) {
    _classCallCheck(this, DynamicDistributedAssets);

    /* BINDABLE : INJECTS */
    Object.assign(this, {
      $stateParams: $stateParams,
      $timeout: $timeout,
      DeliveryResourceFactory: DeliveryResourceFactory,
      AssetResourceFactory: AssetResourceFactory,
      DestinationResourceFactory: DestinationResourceFactory
    });
    /* BINDABLE : DATA */

    var scrubbedParams = angular.copy($stateParams);
    delete scrubbedParams.id;
    this.SearchParams = scrubbedParams;
    this.deliveryThumbs = {};
    this.orderGroupDestinations = {};
    this.referenceLinks = {};
    this.metadataOverrides = {};
    this.destinationCallLetters = {};
    /* EVENTS */
    //Register any event listeners
    // Start things rolling

    this.reloadPages_();
  }
  /* IMPLEMENTATION : BINDABLE */


  _createClass(DynamicDistributedAssets, [{
    key: "getItemAtIndex",
    value: function getItemAtIndex(index) {
      var pageNumber = Math.floor(index / this.PAGE_SIZE);
      var page = this.loadedPages[pageNumber];

      if (page) {
        return page[index % this.PAGE_SIZE];
      } else if (page !== null) {
        this.fetchPage_(pageNumber);
      }
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.numItems;
    }
  }, {
    key: "setItemAtIndex",
    value: function setItemAtIndex(index, item) {
      var pageNumber = Math.floor(index / this.PAGE_SIZE);
      var page = this.loadedPages[pageNumber]; // Only update the screen if the asset is currently loaded

      if (page) {
        page[index % this.PAGE_SIZE] = item;
      }
    }
  }, {
    key: "fetchPage_",
    value: function fetchPage_(pageNumber) {
      var _this = this;

      var self = this;
      self.searching = true; // Set the page to null so we know it is already being fetched.

      self.loadedPages[pageNumber] = null;
      var pageOffset = pageNumber * self.PAGE_SIZE;
      var sortField = self.$stateParams.sortField ? self.$stateParams.sortField : 'OrderGroup.DistributionOrder.date_created';
      var sortDirection = self.$stateParams.sortDirection ? self.$stateParams.sortDirection : 'DESC';
      this.$timeout(function () {
        // Filter out blank values, since we don't want to search by those
        for (var prop in _this.SearchParams) {
          if (_this.SearchParams.hasOwnProperty(prop)) {
            _this.SearchParams[prop] = _this.SearchParams[prop] === '' || _this.SearchParams[prop] === null ? undefined : _this.SearchParams[prop];
          }
        }

        _this.SearchParams.offset = pageOffset;
        _this.SearchParams.limit = self.PAGE_SIZE;
        _this.SearchParams.sortField = sortField;
        _this.SearchParams.sortDirection = sortDirection;
        _this.SearchParams.sortType = 'delivery';
        var sendParams = angular.copy(_this.SearchParams);

        _this.DeliveryResourceFactory.getAllForProvider(sendParams, {}, function success(deliveries) {
          deliveries = deliveries.data;
          self.loadedPages[pageNumber] = deliveries.rows;
          self.numItems = deliveries.count;
          self.loadedPages[pageNumber] = self.loadedPages[pageNumber].map(function (data, ind, list) {
            if (data.Spot && data.Spot.ThumbnailAsset && data.Spot.ThumbnailAsset.AssetContent && data.Spot.ThumbnailAsset.AssetContent.contentUuid) {
              self._getThumbnail(data.Spot.isci, data.Spot.ThumbnailAsset.AssetContent.contentUuid);
            } // This if should never be needed


            if (data.OrderGroup && data.OrderGroup.id) {
              self._getDestinations(data.Spot.id, data.OrderGroup.id);
            } else {
              // if we get in here, we're grabbing bad assets somehow
              // let's throw a random garbage error we can search for
              console.log('Error Code: 345786574');
            } // Reference link shenanigans


            if (data.OrderGroup && data.OrderGroup.DistributionOrder) {
              self._getAssociatedData(data.Spot.id, data.OrderGroup.DistributionOrder.id, data.OrderGroup.id);
            }

            return data;
          });
          self.searching = false;
        }, function failure(err) {
          console.log(err);
          self.loadedPages[pageNumber] = [];
        });
      });
    }
  }, {
    key: "reloadPages_",
    value: function reloadPages_() {
      /**
       * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
       */
      this.loadedPages = {};
      /** @type {number} Total number of items. */

      this.numItems = 0;
      /** @const {number} Number of items to fetch per request. */

      this.PAGE_SIZE = 50;
      this.getItemAtIndex(0);
    }
    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

  }, {
    key: "_getThumbnail",
    value: function _getThumbnail(isci, uuid) {
      var self = this;
      this.AssetResourceFactory.getImageAsset({
        uuid: uuid
      }, {}, function success(asset) {
        var blob = new Blob([asset.data], {
          type: asset.config['Content-Type']
        });
        self.deliveryThumbs[isci] = URL.createObjectURL(blob);
      }, function failure(err) {// Unable to retrieve the image asset for the thumbnail
      });
    }
  }, {
    key: "_getDestinations",
    value: function _getDestinations(spotId, orderGroupId) {
      var _this2 = this;

      // Don't make extra calls if we don't need to
      if (this.orderGroupDestinations[spotId + '-' + orderGroupId] !== undefined) {
        return;
      } // Pre-populate so that it doesn't get duplicated while the request is still out


      this.orderGroupDestinations[spotId + '-' + orderGroupId] = true; // Retrieve all destinations for the given group and return them

      this.DestinationResourceFactory.getOrderGroupDestinations({
        spotId: spotId,
        orderGroupId: orderGroupId
      }, function (destinations) {
        var byType = {};
        var callLetterList = '';
        angular.forEach(destinations.data, function (dest, index, arr) {
          if (callLetterList !== '') {
            callLetterList += ', ';
          }

          callLetterList += dest.alias;

          if (dest.DestinationType === null) {
            dest.DestinationType = {
              labelProperty: 'No Type'
            };
          }

          if (byType[dest.DestinationType.labelProperty] === undefined) {
            byType[dest.DestinationType.labelProperty] = {
              successes: 0,
              failures: 0,
              total: 0
            };
          }

          if (['COMPLETED', 'DOWNLOAD_AVAILABLE'].indexOf(dest.ContainerOrderGroups[0].OGItems[0].deliveryStatus) > -1) {
            byType[dest.DestinationType.labelProperty].successes++;
          } else {
            byType[dest.DestinationType.labelProperty].failures++;
          }

          byType[dest.DestinationType.labelProperty].total++;
        });
        _this2.destinationCallLetters[spotId + '-' + orderGroupId] = callLetterList;
        _this2.orderGroupDestinations[spotId + '-' + orderGroupId] = byType;
      }, function (err) {
        console.log(err);
      });
    }
  }, {
    key: "_getAssociatedData",
    value: function _getAssociatedData(spotId, orderId, orderGroupId) {
      var _this3 = this;

      // Retrieve the reference link for the given spot
      this.DeliveryResourceFactory.getReferenceLink({
        spotId: spotId,
        orderId: orderId
      }, function (refLink) {
        if (refLink && refLink.data) {
          _this3.referenceLinks[spotId + '-' + orderId] = refLink.data.link;
        } else {
          _this3.referenceLinks[spotId + '-' + orderId] = '';
        }
      }, function failure(err) {
        console.log(err);
      }); // Retrieve the orderItemMetadataOverride for the given spot

      this.DeliveryResourceFactory.getMetadataOverride({
        spotId: spotId,
        orderId: orderId,
        orderGroupId: orderGroupId
      }, function (metadataOverride) {
        if (metadataOverride && metadataOverride.data) {
          _this3.metadataOverrides[spotId + '-' + orderId + '-' + orderGroupId] = metadataOverride.data;
        } else {
          _this3.metadataOverrides[spotId + '-' + orderId + '-' + orderGroupId] = '';
        }
      }, function failure(err) {
        console.log(err);
      });
    }
    /* INITIALIZATION */

  }, {
    key: "$onInit",
    value: function $onInit() {}
  }]);

  return DynamicDistributedAssets;
}();